"use client";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

const useGetQueryState = (query: string, setState: (state: any) => void) => {
  const searchParams = useSearchParams();
  const queryState = searchParams.get(query);
  useEffect(() => {
    if (typeof queryState === "string") {
      setState([queryState]);
    }
    if (Array.isArray(queryState)) {
      setState(queryState);
    }
  }, [queryState, setState]);
};

export const useGetQuerySearch = (
  query: string,
  setState: (state: any) => void
) => {
  const searchParams = useSearchParams();
  const queryState = searchParams.get(query);
  useEffect(() => {
    if (typeof queryState === "string") {
      setState(queryState);
    }
    if (Array.isArray(queryState)) {
      setState(queryState[0] || "");
    }
  }, [queryState, setState]);
};

export default useGetQueryState;

export const useSetQueryState = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const setQueryState = (queryKey: string, newValues: string[]) => {
    const newParamsArray = [];

    for (const [key, value] of searchParams.entries() as unknown as [
      string,
      string
    ][]) {
      if (key === queryKey) {
        newValues.forEach((value) => {
          newParamsArray.push(`${key}=${value}`);
        });
      } else {
        newParamsArray.push(`${key}=${value}`);
      }
    }

    const newParams = newParamsArray.join("&");

    router.replace(pathname + "?" + newParams);

    // router.replace(
    //   {
    //     pathname,
    //     query: {
    //       ...query,
    //       [queryKey]: newValues,
    //     },
    //   }
    // );
  };
  return setQueryState;
};

export const useQueryState = <T extends string>(
  key: string,
  initialState: T,
  { shallow = true, replace = false } = {}
) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const val = searchParams.get(key);

  const setValue = (value: T | ((arg: T) => T)) => {
    const newParams = new URLSearchParams(searchParams.toString());
    const newValue =
      typeof value === "function" ? value((val as T) || initialState) : value;
    if (!newValue) {
      newParams.delete(key);
    } else {
      newParams.set(key, newValue);
    }

    const newUrl = `${window.location.pathname}?${newParams.toString()}`;

    if (shallow) {
      if (replace) {
        window.history.replaceState({}, "", newUrl);
      } else {
        window.history.pushState({}, "", newUrl);
      }
    } else {
      if (replace) {
        router.replace(newUrl);
      } else {
        router.push(newUrl);
      }
    }
  };

  return [val ?? initialState, setValue] as const;
};
